import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wfq3tnmz7w: FaireBrandEntity = {
  token: "b_wfq3tnmz7w",
  type: "brand",
  name: "Made by Mariah",
  avatarUrl:
    "https://cdn.faire.com/fastly/ee1eb5cf275eacd3c0e98bf0215db200943d08c1b746056ed2a7c751b3612886.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b06623b25bc87110be670545ec42e1a6053b6e8926762db914923460a44e4cdc.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ee1eb5cf275eacd3c0e98bf0215db200943d08c1b746056ed2a7c751b3612886.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b06623b25bc87110be670545ec42e1a6053b6e8926762db914923460a44e4cdc.png",
  location: "Mount Vernon, AR, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 12,
  isInsider: true,
  description:
    "Made by Mariah started when I fell in love with monogramming everything I owned in middle school many years ago. Flash forward and my little hobby turned into a small business where I sell custom products to friends, family, and customers across the world. I love customizing apparel for any and every event or occasion and can't wait to serve you in this way. Each product is handmade to order by me, Mariah, and sent you to from my small town in Arkansas. Thank you for supporting my little dream! XOXO",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:40.023Z",
    importedBy: "entity-db-cli",
  },
};
